var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#FA3079",
    d: "M10.709 33.513H4.22V17.95H.681v-6.512H4.23V8.4c0-4.976 1.679-7.721 7.039-7.721h4.462v5.658h-2.789c-2.087 0-2.224.792-2.224 2.268l-.009 2.832h5.053l-.591 6.503h-4.462v15.573z"
  })));
};
export { SvgFacebook as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIzNCI+CiAgICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGZpbGw9IiNGQTMwNzkiIGQ9Ik0xMC43MDkgMzMuNTEzSDQuMjJWMTcuOTVILjY4MXYtNi41MTJINC4yM1Y4LjRjMC00Ljk3NiAxLjY3OS03LjcyMSA3LjAzOS03LjcyMWg0LjQ2MnY1LjY1OGgtMi43ODljLTIuMDg3IDAtMi4yMjQuNzkyLTIuMjI0IDIuMjY4bC0uMDA5IDIuODMyaDUuMDUzbC0uNTkxIDYuNTAzaC00LjQ2MnYxNS41NzN6Ii8+Cjwvc3ZnPgo=";